import React from 'react';

interface TransactionTabsProps {
    activeTab: 'purchases' | 'usage';
    setActiveTab: (tab: 'purchases' | 'usage') => void;
}

const TransactionTabs: React.FC<TransactionTabsProps> = ({ activeTab, setActiveTab }) => {
    return (
        <div className="border-b border-accent-taupe mb-6">
            <nav className="-mb-px flex space-x-8">
                <button
                    onClick={() => setActiveTab('usage')}
                    className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === 'usage'
                        ? 'border-secondary-500 text-secondary-600'
                        : 'border-transparent text-text-description hover:text-text-heading hover:border-accent-taupe'
                        }`}
                >
                    <i className="fas fa-history mr-2"></i>
                    Usage History
                </button>
                <button
                    onClick={() => setActiveTab('purchases')}
                    className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === 'purchases'
                        ? 'border-secondary-500 text-secondary-600'
                        : 'border-transparent text-text-description hover:text-text-heading hover:border-accent-taupe'
                        }`}
                >
                    <i className="fas fa-shopping-cart mr-2"></i>
                    Purchase History
                </button>
            </nav>
        </div>
    );
};

export default TransactionTabs; 